import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Component, Input }   from '@angular/core';
import { NgbActiveModal }     from '@ng-bootstrap/ng-bootstrap';
import { NgForm }             from '@angular/forms';
import { TranslateService }   from '@ngx-translate/core';

import { ApiService }           from '../api/api.service';
import { BigDecimalService }    from '../core/services/big-decimal.service';
import { DvlaLookupPriceModel } from './models/dvla-lookup.price';
import { DvlaLookupQuoteModel } from './models/dvla-lookup.quote';
import { GlobalCurrencyPipe }   from '../shared/pipes/global-currency.pipe';
import { MessagesService }      from '../messages/messages.service';
import { SessionService }       from '../sessions/session.service';

@Component({
  selector   : 'wor-purchase-dvla-lookups',
  template: require('./dvla-lookup.purchase.component.html')
})
export class PurchaseDvlaLookupsComponent {
  public isPurchasing = false;

  public quote : DvlaLookupQuoteModel = {};

  @BlockUI('purchaseDvlaLookupsBlock') block : NgBlockUI;

  @Input() price : DvlaLookupPriceModel;

  constructor (
    public activeModal        : NgbActiveModal,
    private apiService        : ApiService,
    private bigDecimalService : BigDecimalService,
    private globalCurrencyPipe: GlobalCurrencyPipe,
    private messagesService   : MessagesService,
    private sessionService    : SessionService,
    public translateService   : TranslateService
  ) {}

  confirm () : void {
    this.block.start();

    this.isPurchasing = true;

    this.apiService.post('/chargify/purchase', {
      service : 'dvla_lookup',
      quantity: this.quote.quantity
    })
    .then(() => this.sessionService.refresh())
    .then(() => {
      this.activeModal.close();
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();

      this.isPurchasing = false;
    });
  }

  getLabel ( form : NgForm ) : string {
    if ( this.quote.quantity < 100 || form?.controls?.quantity?.invalid && form?.controls?.quantity?.dirty ) {

      return this.translateService.instant('GENERAL_SPACE.ERROR_MESSAGE.INVALID_QUANTITY');

    }
    else {
      return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.NUMBER_OF_REQUESTS');
    }
  }

  updatePrice ( quantity : string ) : void {


    const price    = this.bigDecimalService.get(this.price.price);

    quantity = this.bigDecimalService.get(quantity);

    this.quote.price = this.globalCurrencyPipe.transform(price.multiply(quantity).toString());


  }
}
